module.exports = __webpack_public_path__ + "img/Hotel Atlantic.9995f2be.jpg";